export default [
  // Flights urls
  {
    path: "airline-flights",
    name: "airline-flights",
    component: () => import("@/views/boarding/flight/AirlineFlights.vue"),
  },
  {
    path: "flights/:flightId/boardingPanel",
    name: "flight-boarding-panel",
    component: () =>
      import("@/views/boarding/flightBoardingPanel/FlightBoardingPanel.vue"),
  },
  {
    path: "flights/:flightId/airline-boarding-panel",
    name: "airline-flight-boarding-panel",
    component: () =>
      import(
        "@/views/boarding/flightBoardingPanel/AirlineFlightBoardingPanel.vue"
      ),
  },
  // Passengers urls
  {
    path: "flights/:flightId/passengers",
    name: "flight-passengers",
    meta: { text: "flightPassengers" },
    component: () =>
      import("@/views/boarding/flightPassenger/FlightPassengers.vue"),
  },
  {
    path: "flights/:flightId/passengerList/:columnsToPrint",
    name: "flight-passenger-list",
    component: () => import("@/views/boarding/passengerList/PassengerList.vue"),
  },
  {
    path: "flights/passengers/:flightPassengerId",
    name: "flight-passenger",
    component: () =>
      import("@/views/boarding/flightPassenger/FlightPassengerDetail.vue"),
    children: [
      {
        path: "details",
        name: "flight-passenger-details",
        meta: { text: "passengerDetails" },        
        component: () =>
          import("@/views/boarding/components/FlightPassengerDetails.vue"),
      },
      {
        path: "events",
        name: "flight-passenger-events",
        component: () =>
          import("@/views/boarding/components/FlightPassengerEvents.vue"),
      },
    ],
  },
  {
    path: "crews",
    name: "crews",
    component: () => import("@/views/boarding/crew/CrewList.vue"),
  },
  {
    path: "crews/:crewId",
    name: "crew-detail",
    component: () => import("@/views/boarding/crew/CrewDetail.vue"),
  },
];
